import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import './main-form.css';
import RightTab from './RightTab';
import LeftTab from './LeftTab';
import { Tabs, Icon } from 'antd';
import { FaBoxes } from 'react-icons/fa';
import { isDevENV } from '../../util/isDevENV';
const { TabPane } = Tabs;

/**
 * @component
 * @category Form Page
 * @name AdvanceForm
 * @description It contains top tabs i.e. FCl or CONTAINERS tab
 * and LCL/AIR or PALLETS/BOXES/CRATES tab
 * <br> <br>
 * **Example**
 * ```js
 *   <Form />
 * ```
 */
class AdvanceForm extends Component {
    state = {
        nextBtnClick: isDevENV() ? 3 : 0, //make it to 0 in production
    };

    componentDidMount = () => {
        this.props.updateLoadSummaryText();
        // console.log('isFormSubmitSuccess: ', this.props.isFormSubmitSuccess);
        // if form is already used then don't show next-step button at all
        //increase it's count to max. i.e. 3
        if (this.props.isFormSubmitSuccess) {
            this.setState({ nextBtnClick: 3 });
        }
    };

    /**
     * @description there are two next-step button will appear on FCL mode and LCL/AIR (total shipment) mode
     * But there are three next-step button will appear on LCL/AIR (box/pallet) mode.
     * if custom service is NOT shown, then there would be ONE less next-step button than it used to be.
     * It increases next-step button counter upon click on it.
     * <br> <br>
     * **onNextBtnClick() -> {void}**
     * <br><br>
     * Returns: Type: void
     */
    onNextBtnClick = () => {
        this.setState(
            (prevState) => ({ nextBtnClick: 1 + prevState.nextBtnClick }),
            () => {
                // console.log('onNextBtnClick: ', this.state.nextBtnClick);
            }
        );
    };

    /**
     * @description It's fired when users change the tabs on Form modal
     * <br> <br>
     * **onTabsChange(activeKey) -> {void}**
     * <br><br>
     * **Parameters:**
     * | Name          | Type          | Description  |
     * | :------------ |:------------- | :------------|
     * | activeKey     | string        | `1` - when LCL tab is active, `2` - when FCL tab is active|

     * Returns: Type: void
     */
    onTabsChange = (activeKey) => {
        console.log(activeKey);
        this.props.updateActiveTabpane(Number(activeKey) === 2);
        this.props.updateLoadSummaryText();
    };


    render() {
        const { nextBtnClick } = this.state;
        const { isFclTabActive } = this.props;

        return (
            <div style={{}} className="form-root">
                <Tabs
                    defaultActiveKey={isFclTabActive ? '2' : '1'}
                    onChange={this.onTabsChange}
                >
                    <TabPane
                        tab={
                            <span className="my-tab-header">
                <FaBoxes
                    size={25}
                    style={{ marginRight: '10px', marginBottom: '-5px' }}
                />
                PALLETS / BOXES / CRATES
              </span>
                        }
                        key="1"
                    >
                        <LeftTab
                            nextBtnClick={nextBtnClick}
                            onNextBtnClick={this.onNextBtnClick}
                        />
                    </TabPane>
                    <TabPane
                        tab={
                            <span className="my-tab-header">
                <Icon
                    type="container"
                    style={{
                        marginRight: '10px',
                        fontSize: '25px',
                    }}
                />
                CONTAINERS
              </span>
                        }
                        key="2"
                    >
                        <RightTab
                            nextBtnClick={nextBtnClick}
                            onNextBtnClick={this.onNextBtnClick}
                        />
                    </TabPane>
                </Tabs>
            </div>
        );
    }
}

AdvanceForm.propTypes = {
    /**
     * whether FCL/Containers tab is selected
     */
    isFclTabActive: PropTypes.bool,
    /**
     * Whether Form is successfully submitted for first time.
     */
    isFormSubmitSuccess: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        isFclTabActive: state.form.isFclTabActive,
        isFormSubmitSuccess: state.form.isFormSubmitSuccess,
    };
};

export default connect(mapStateToProps, actions)(AdvanceForm);
